import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { useHistory } from 'react-router-dom'

import { ModalBase, Botao, IconeModalSucesso } from 'src/componentes'
import { RotasAluno } from 'src/rotas/aluno'

import { Corpo, Texto, Titulo } from './styles'
import {
  ModalPagamentoRequerimentoProps,
  ModalPagamentoRequerimentoRef
} from './tipos'

const ModalPagamento: React.ForwardRefRenderFunction<
  ModalPagamentoRequerimentoRef,
  ModalPagamentoRequerimentoProps
> = ({ backdrop, ehBoleto, pix }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const history = useHistory()

  const fechar = () => {
    definirAberta(false)
  }

  const abrir = () => {
    definirAberta(true)
  }

  const pixOuBoleto = pix === 'Boleto' ? 'Boleto bancário' : 'Pix'

  useImperativeHandle<
    ModalPagamentoRequerimentoRef,
    ModalPagamentoRequerimentoRef
  >(ref, () => ({
    fechar,
    abrir
  }))

  const acaoSucesso = () => {
    fechar()
    history.push(RotasAluno.Requerimentos)
  }

  return (
    <ModalBase aberta={aberta} backdrop={backdrop}>
      <Corpo>
        {IconeModalSucesso}
        <Titulo>Requerimento realizado com sucesso!</Titulo>
        {ehBoleto ? (
          <>
            <Texto>
              Você finalizou seu requerimento de Certificado Impresso,
              escolhendo pagar a Taxa de Requerimento através de {pixOuBoleto},
              e por isso, começaremos a realizar sua solicitação em até 24h após
              o pagamento deste boleto.
            </Texto>
          </>
        ) : (
          <>
            <Texto>
              Você finalizou seu requerimento de Certificado Impresso e com esta
              forma de pagamento nós já iremos começar a realizar sua
              solicitação.
            </Texto>
          </>
        )}
        <Botao texto="OK" type="button" onClick={() => acaoSucesso()} />
      </Corpo>
    </ModalBase>
  )
}

export const ModalPagamentoRequerimento = forwardRef(ModalPagamento)
